<template>
  <div v-if="loaded">
    <vs-tabs :position="isSmallerScreen ? 'left' : 'left'" class="tabs-shadow-none" v-model="tabNotFullfil"
             id="profile-tabs" :key="isSmallerScreen">
      <!-- GENERAL -->
      <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? $t('menus.user.general') : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <user-general v-model="user.dataGeneral" @submitData="submitData"/>
        </div>
      </vs-tab>

      <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? $t('menus.user.info') : ''">
        <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
          <user-info v-model="user.dataInfo" @submitData="submitData" required/>
        </div>
      </vs-tab>

      <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? $t('menus.user.address') : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <user-address v-model="user.dataAddress" :save-button="true" @submitData="submitData" force-scroll/>
        </div>
      </vs-tab>

      <vs-tab icon-pack="feather" icon="icon-lock" :label="!isSmallerScreen ? $t('menus.user.password') : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <profile-settings-change-password :user-id="user.id"/>
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
// import UserSettingsSocialLinks from './profileSettings/UserSettingsSocialLinks.vue'
// import UserSettingsConnections from './profileSettings/UserSettingsConnections.vue'
// import UserSettingsNotifications from './profileSettings/UserSettingsNotifications.vue'

import UserGeneral from './profileSettings/UserGeneral.vue';
import ProfileSettingsChangePassword from './profileSettings/ChangePassword.vue';
import UserInfo from '@/views/profileSettings/UserInfo';
import UserAddress from '@/views/profileSettings/UserAddress';

import ProfileService from "@/services/Profile.service";
import {User} from "@/models/User.model"

import {showErrorNotify, showSuccessNotify, setProfile} from "@/helpers/functionsHelpers";

export default {
  components: {
    UserGeneral,
    UserAddress,
    ProfileSettingsChangePassword,
    UserInfo,
  },
  data () {
    return {
      user: new User(),

      tabNotFullfil: 0,
      loaded: false
    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    },
    isValid() {
      if (this.user) {
        const dataGeneralValid = this.user.dataGeneral.isDataGeneralValid();
        const dataAddressValid = this.user.dataAddress.isDataAddressValid();
        const dataInfoValid = this.user.dataInfo.isDataInfoValid();
        console.debug('Profile Validation = ', (dataGeneralValid && dataAddressValid && dataInfoValid));
        return dataGeneralValid && dataAddressValid && dataInfoValid;
      } else {
        return false;
      }
    },
  },
  methods: {
    initValues() {
      this.user = new User();
    },
    setUnfullfilTabs() {
      if (!this.user.dataGeneral.isDataGeneralValid()) {
        this.tabNotFullfil = 0;
      }

      if (!this.user.dataInfo.isDataInfoValid()) {
        this.tabNotFullfil = 1;
      }

      if (!this.user.dataAddress.isDataAddressValid()) {
        this.tabNotFullfil = 2;
      }
    },
    submitData() {
      ProfileService.updateProfile(this.user).then((response) => {
        this.$store.dispatch('Profile/updateProfileData', response).then((profile) => {
          setProfile(this, profile);
          this.user = User.FromObj(profile);
          this.setUnfullfilTabs();

          if (this.user.isUserFulFill()) {
            showSuccessNotify(this, this.$t('pages.users.updateOk'));
            this.$router.push({name: 'home'});
          } else {
            this.$alma.dialogConfirm({
              isOkModal: true,
              title: this.$t('pages.users.updateProfileTitle'),
              textBody: this.$t('pages.users.updateProfileBody'),
            });
          }
        });
      }, error => {
        showErrorNotify(this, error);
      });
    },
    resetSubmit() {
      this.initValues();
      this.user = User.FromObj(this.$store.getters['Profile/profileData']);
      console.debug('Profile reseted to => ', this.user);
    }
  },
  mounted() {
    //Execute all code synchronous
    ProfileService.getProfile().then((response) => {
      setProfile(this, response).then((profile) => {
        this.user = User.FromObj(profile);
        console.debug('Profile updates to => ', this.user);
        if (this.user.getDisplayName().includes('@')) {
          this.user.dataGeneral.displayName = '';
        }
        this.setUnfullfilTabs();
        this.loaded = true;
      });

    }, (error) => {
      showErrorNotify(this, error);
    });
  },
}
</script>

<style lang="scss">
  #profile-tabs {
    .vs-tabs--content {
      padding: 0;
    }
}
</style>
